import { FC } from 'react'
import { useDomain } from 'context'
import { Link } from 'interweave-autolink'
import styled, { css } from 'styled-components'
import Button from '@app.components/Button'
import { useScrapStateContext } from '../../../../screens/ScrapScreen/useScrapState'
import { getNoScrapMessage } from '../modules/getNoScrapMessage'

const ScrapListNotFound: FC = () => {
  const context = useScrapStateContext()
  const domains = useDomain()
  const { tabState } = context

  const { heading, subText, actions } = getNoScrapMessage(tabState, domains)

  return (
    <StyledWrapper>
      <p className="heading-text-box">
        <span className="highlight-text ">{heading.highlightText}</span>
        <span className="heading-text">{heading.text}</span>
      </p>
      <p className="sub-text">{subText}</p>
      <div>
        {actions.map((action, index) => (
          <Link href={action.link} key={index}>
            <Button className="action-button">{action.name}</Button>
          </Link>
        ))}
      </div>
    </StyledWrapper>
  )
}

export default ScrapListNotFound

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0px;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      height: 50vh;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
    `}

  .heading-text-box {
    font-size: 20px;
    width: 100%;
    text-align: center;
  }

  .highlight-text {
    color: #01a0ff;
  }
  .heading-text {
    color: #333333;
  }

  .sub-text {
    color: #999999;
    font-size: 16px;
    margin: 10px 0px 20px;
  }
  .action-button {
    font-size: 12px;
    padding: 11px 20px;
    margin-left: 5px;
    background-color: #eeeeee;
    color: black;
    &:hover {
      background-color: #d5d5d5;
    }
  }
`
